import type { CSSProperties } from 'react'

export const DONUT_CHART_DEFAULT_SIZE = 240
export const DONUT_CHART_DEFAULT_TITLE = 'Title'
export const DONUT_CHART_DEFAULT_VALUE = 83

/** Figma innerRadius 0.8 → ring is 20% of radius (24px on a 240px chart). */
export const DONUT_CHART_INNER_RADIUS_RATIO = 0.8

export const DONUT_CHART_TRACK_COLOR = 'var(--ds-blue-300)'
export const DONUT_CHART_PROGRESS_COLOR = 'var(--ds-blue-500)'
export const DONUT_CHART_VALUE_COLOR = 'var(--ds-blue-700)'

export type DonutChartProps = {
  /** Progress from 0–100. Defaults to 83. */
  value?: number
  /** Center label above the value. Defaults to "Title". */
  title?: string
  /** Hide the center title. */
  hideTitle?: boolean
  /** Override the formatted center value (defaults to rounded `value%`). */
  valueLabel?: string
  /** Hide the center value. */
  hideValue?: boolean
  /** Diameter in px. Defaults to 240. */
  size?: number
  /** Track (remaining) color. */
  trackColor?: string
  /** Progress arc color. */
  progressColor?: string
  /** Dark surface — lightens center labels. */
  darkMode?: boolean
  className?: string
  style?: CSSProperties
  'aria-label'?: string
}
